import AppRoutes from '@routes/AppRoutes';

function App() {
	return (
		<main>
			<AppRoutes />
		</main>
	);
}

export default App;
